/**
 * src/components/ui/Label.tsx
 * =============================================================================
 * Label para inputs de formulario. Tipografía pequeña, peso medio.
 * =============================================================================
 */

import type { LabelHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export function Label({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label
      className={cn(
        'block text-sm font-medium text-foreground mb-1.5',
        'peer-peer-disabled:opacity-70',
        className,
      )}
      {...props}
    />
  )
}
